import hardCopyTypeMap from '../modules/Taps/constants/hardCopyTypeMap';
import registrationTypeMap from '../modules/Taps/constants/registrationPageTypeMap';
import config from '../config';
import REACT_CONFIG from 'REACT_CONFIG';

export const routeMap = Object.freeze({
  home: '/',
  login: '/login',
  info: '/info',
  openPdf: '/openPdf',
  surveySupportMeasures: '/survey/supportMeasures',
  previewPdf: config.pdfPreviewIsActive ? '/previewPdf' : '/openPdf',
  openTapsPdf: '/openTapsPdf',
  lkIp: '/openLkIp',
  siteMap: '/siteMap',
  error: '/error',
  bankRedirect: '/redirectToBank',
  login_backend: `${config.authBasePath}/oauth/token`,
  armLoginBackend: `${config.authBasePath}/oauth/token`,
  checkToken: '/auth/oauth/check_token',
  armCheckToken: '/auth-ofc/oauth/check_token',
  captcha: '/auth/captcha',
  logout: '/auth/oauth/revoke',
  armLogout: '/auth-ofc/oauth/revoke',
  armRunAs: '/auth-ofc/oauth/run-as',
  esiaRedirect: `/auth/oauth/esia`,
  report: '/report',
  taxes: '/myTaxes',
  taxesDetail: '/myTaxes/detail',
  incomeTaxesDetail: '/myTaxes/incomeTax/detail',
  payment: '/payment',
  messages: '/messages',
  judicialOrder: '/messages/judicialOrder/:cardId',
  messagesInfo: '/messages/details',
  contacts: '/contacts',
  contactsSearch: '/contacts/search',
  makeAppointment: '/contacts/appointment',
  appointmentDetail: '/contacts/appointment/:id',
  contactsDetail: '/contacts/:id',
  help: '/help',
  helpBiggest: '/helpBiggest',
  helpServices: '/help/services',
  faq: '/faq',
  faqServices: '/faq/services',
  taxesWallet: '/myTaxes/wallet',
  taxesWalletPayment: '/myTaxes/wallet/payment',
  taxesPayment: '/myTaxes/payment',
  paymentBank: '/myTaxes/payment/bank',
  incomeTax: '/myTaxes/incomeTax',
  admFines: '/myTaxes/admFines',
  landTax: '/myTaxes/landTax',
  overpayment: '/myTaxes/overpayment',
  propertyTax: '/myTaxes/propertyTax',
  transportTax: '/myTaxes/transportTax',
  operationsHistory: '/myTaxes/operationsHistory',
  administrativeFines: '/myTaxes/administrativeFines',
  propertyObjects: '/propertyObjects',
  propertyObject: '/propertyObjects/:objectId',
  profile: '/profile',
  profilePersonalData: '/profile/personalData',
  participationInOrganizations: '/profile/participationInOrganizations',
  profileActivityHistory: '/profile/activityHistory',
  profileSign: '/profile/sign',
  survey: '/profile/survey',
  profileAccountsAbroad: '/profile/accountsAbroad',
  profileAccounts: '/profile/accounts',
  profileInvestAccounts: '/profile/investAccounts',
  profileAccountDetails: '/profile/accountsAbroad/details',
  profileFamilyAccess: '/profile/familyAccess',
  profileFamilyAccessHided: '/profile/familyAccessHided',
  calendar: '/profile/calendar',
  checks: '/myTaxes/checks',
  searchAndLoadCheck: '/myTaxes/checks/searchAndLoadCheck',
  situations: '/situations',
  mobilizationReport: '/situations/mobilizationReport',
  otherSituations: '/situations/other',
  requestArmyMeasures: '/situations/requestArmyMeasures',
  registrationsPage: '/situations/other/registrations',
  registrationsWithTaxAuthority: '/situations/other/registrations/:page',
  exemptions: '/situations/exemptions',
  incorrectAccrual: '/situations/incorrectAccrual',
  exemptionsNotification: '/situations/exemptions/notification',
  applyExemptionOld: '/situations/exemptions/applyingOld',
  applyExemption: '/situations/exemptions/applying',
  landTaxDeduction: '/situations/exemptions/landTaxDeduction',
  updateObjectData: '/situations/incorrectAccrual/update',
  objectDestruction: '/situations/incorrectAccrual/objectDestruction',
  transportDestruction: '/situations/incorrectAccrual/transportDestruction',
  updatePersonalData: '/situations/updatePersonalData',
  detailsOrderClarification: '/situations/detailsOrderClarification',
  foreignObject: '/situations/incorrectAccrual/foreignObject',
  addObject: '/situations/incorrectAccrual/addObject',
  makeComplaint: '/situations/other/makeComplaint',
  appealInFreeForm: '/situations/other/appealInFreeForm',
  taxSecrecy: '/situations/other/taxSecrecy',
  consentToPublicKnowledge: '/situations/other/taxSecrecy/consentToPublicKnowledge',
  reportExistenceObject: '/situations/reportExistenceObject',
  ndfl3: '/situations/3NDFL',
  ndfl3Declaration: '/situations/3NDFL_declaration',
  ndfl3SendXML: '/situations/3NDFL_send_XML/:page',
  ndfl3ViewDeclaration: '/situations/3NDFL_view_declaration/:declarationId',
  ndfl3ViewDeclarationAttachedDocs: '/situations/3NDFL_view_declaration/:declarationId/attach_docs',
  ndfl3ViewDeclarationAttachedDocsSuccess:
    '/situations/3NDFL_view_declaration/:declarationId/attach_docs_success',
  deductions: '/situations/deductions',
  socialDeductions: '/situations/referenceMaterials/social',
  requestExecutionResponsibility: '/situations/referenceMaterials/requestExecutionResponsibility',
  requestForReconciliationAct: '/situations/referenceMaterials/requestForReconciliationAct',
  referenceMaterials: '/situations/referenceMaterials',
  referenceAboutCalcStatus: '/situations/referenceMaterials/calculationStatus',
  rejectLKFL: '/situations/other/rejectLKFL',
  disposeOfOverpayment: '/situations/disposeOfOverpayment',
  disposeOfOverpaymentEnp: '/situations/disposeOfOverpaymentEnp',
  percentDepositsSituation: '/situations/percentDeposits',
  judicialActs: '/myTaxes/judicialActs',
  selfInsuranceTaxes: '/myTaxes/selfInsuranceTaxes',
  unexplainedPayments: '/myTaxes/unexplainedPayments',
  hardCopy: '/situations/other/hardCopy/:actionType',
  cameralAudits: '/messages/cameralAudits/:id',
  undefinedObject: '/situations/undefinedObject',
  incorrectAccrualForObject: '/situations/incorrectAccrual/forObject',
  noChargesAppeal: '/situations/incorrectAccrual/noChargesAppeal',
  openLkApi: '/openLkApi',
  externalServices: '/externalServices',
  setAddressToSendingTaxDocuments: '/situations/other/setAddressToSendingTaxDocuments',
  ndfl3LightDeduction: '/situations/ndfl3LightDeduction',
  ndfl3LightIncome: '/situations/ndfl3LightIncome',
  ndfl3LightDeductionCharity: '/situations/ndfl3LightDeduction/charityDeduction',
  ndfl3LightDeductionIIS: '/situations/ndfl3LightDeduction/iisDeduction',
  ndfl3LightDeductionHealing: '/situations/ndfl3LightDeduction/healingDeduction',
  ndfl3LightDeductionEducation: '/situations/ndfl3LightDeduction/educationDeduction',
  ndfl3LightDeductionProperty: '/situations/ndfl3LightDeduction/propertyDeduction',
  ndfl3LightIncomeRental: '/situations/ndfl3LightIncome/rentalIncome',
  ndfl3LightIncomeProperty: '/situations/ndfl3LightIncome/propertySalesIncome',
  externalAppointment: '/externalAppointment',
  appointmentGetManagement: '/appointment/getManagement',
  appointmentGetIFNS: '/appointment/getIfns',
  appointmentGetTorm: '/appointment/getTorm',
  appointmentGetServices: '/appointment/getServices',
  appointmentGetSlots: '/appointment/getSlots',
  appointmentBook: '/appointment/book',
  appointmentCancelBooking: 'appointment/cancelBooking',
  paymentInfo: '/profile/paymentInfo',
  incomesAndTaxDeductions: '/incomesAndTaxDeductions',
  taxDeductions: '/incomesAndTaxDeductions/taxDeductions',
  userIncomes: '/incomesAndTaxDeductions/userIncomes',
  declarationIncomes: '/incomesAndTaxDeductions/userIncomes/declarationIncomes',
  insuranceTaxes: '/incomesAndTaxDeductions/userIncomes/insuranceTaxes',
  percentDeposits: '/incomesAndTaxDeductions/userIncomes/percentDeposits',
  declarations: '/incomesAndTaxDeductions/declarations',
  innCertificateRequest: '/situations/referenceMaterials/innCertificateRequest',
  qualifiedSignatureApplication: '/situations/qualifiedSignatureApplication',
  requestForSearchPayment: '/situations/other/searchPayment',
  simplifiedDeductions: '/situations/simplifiedDeductions',
  consentToInform: '/situations/other/consentToInform',
});

const authOfcClientPath = REACT_CONFIG.REACT_APP_LOGIN_PATH || '/auth-ofc-client';
const { hrefToNewLK } = config;
export const remotePaths = {
  taxpayerSearching: `${authOfcClientPath}/searchTaxpayer`,
  login: `${authOfcClientPath}/searchTaxpayer`,
  homePage: hrefToNewLK,
  messages: `${hrefToNewLK}/messages`,
  taxes: `${hrefToNewLK}/individual/taxes`,
  unexplainedPayments: `${hrefToNewLK}/individual/taxes/unexplainedPayments`,
  selfInsuranceTaxes: `${hrefToNewLK}/individual/taxes/selfInsuranceTaxes`,
  checks: `${hrefToNewLK}/individual/receipts`,
  profile: `${hrefToNewLK}/profile-information/individual/personalData/info`,
  profileActivityHistory: `${hrefToNewLK}/profile-information/individual/operationHistory`,
  profileSign: `${hrefToNewLK}/profile-settings/common/sign`,
  profileAccountsAbroad: `${hrefToNewLK}/profile-information/individual/myBills?bank=foreign`,
  participationInOrganizations: `${hrefToNewLK}/profile-information/individual/participationInOrganizations`,
  profileAccounts: `${hrefToNewLK}/profile-information/individual/myBills?bank=russian`,
  profileFamilyAccess: `${hrefToNewLK}/profile-settings/common/familyAccess`,
  propertyObjects: `${hrefToNewLK}/individual/propertyObjects`,
  situations: `${hrefToNewLK}/individual/appeals`,
  statementOfEgrn: `${hrefToNewLK}/individual/appeals/referenceMaterials/statementOfEgrn`,
  noChargesAppeal: `${hrefToNewLK}/individual/appeals/incorrectAccrual/noChargesAppeal`,
  needHardCopy: `${hrefToNewLK}/individual/appeals/other/needHardCopy`,
  refusalHardCopy: `${hrefToNewLK}/individual/appeals/other/refusalHardCopy`,
  makeComplaint: `${hrefToNewLK}/individual/appeals/other/makeComplaint`,
  registerAsMediator: `${hrefToNewLK}/individual/appeals/registerTaxAuthority/registerAsMediator`,
  unregisterAsMediator: `${hrefToNewLK}/individual/appeals/registerTaxAuthority/unregisterAsMediator`,
  registerAsInsuranceTaxPayer: `${hrefToNewLK}/individual/appeals/registerTaxAuthority/registerAsInsuranceTaxPayer`,
  unregisterAsInsuranceTaxPayer: `${hrefToNewLK}/individual/appeals/registerTaxAuthority/unregisterAsInsuranceTaxPayer`,
  rejectLKFL: `${hrefToNewLK}/individual/appeals/other/rejectLKFL`,
  social: `${hrefToNewLK}/individual/appeals/referenceMaterials/social`,
  innCertificateRequest: `${hrefToNewLK}/individual/appeals/referenceMaterials/innCertificateRequest`,
  consentToInform: `${hrefToNewLK}/individual/appeals/other/consentToInform`,
  userIncomes: `${hrefToNewLK}/individual/incomesAndTaxDeductions/income/incomes`,
  declarations: `${hrefToNewLK}/individual/incomesAndTaxDeductions/declarations`,
  taxDeductions: `${hrefToNewLK}/individual/incomesAndTaxDeductions/taxDeductions`,
  insuranceTaxes: `${hrefToNewLK}/individual/incomesAndTaxDeductions/income/insuranceTaxes`,
  percentDeposits: `${hrefToNewLK}/individual/incomesAndTaxDeductions/income/percentDeposits`,
  help: `${hrefToNewLK}/help/information-center/start-of-work`,
  helpServices: `${hrefToNewLK}/help/information-center/help-services`,
  contacts: `${hrefToNewLK}/profile-information/individual/inspections`,
  appealTaxAddress: `${hrefToNewLK}/individual/appeals/other/setAddressToSendingTaxDocuments`,
  factOfGettingSocialDeductions: `${hrefToNewLK}/individual/appeals/individualInvestmentAccount/notReceivedInvestmentAccountDeduction`,
  kikNotification: `${hrefToNewLK}/individual/appeals/foreignOrganizations/kikNotification`,
  informParticipationForeignOrganizations: `${hrefToNewLK}/individual/appeals/foreignOrganizations/informParticipationForeignOrganizations`,
  propertyTaxDeductions: `${hrefToNewLK}/individual/appeals/referenceMaterials/propertyTax`,
};

export const pathsCompliance = {
  '/old/siteMap': remotePaths.homePage,
  '/old/messages': remotePaths.messages,
  '/old/myTaxes': remotePaths.taxes,
  '/old/myTaxes/operationsHistory': remotePaths.taxes,
  '/old/myTaxes/wallet': remotePaths.taxes,
  '/old/myTaxes/unexplainedPayments': remotePaths.unexplainedPayments,
  '/old/myTaxes/selfInsuranceTaxes': remotePaths.selfInsuranceTaxes,
  '/old/checks': remotePaths.checks,
  '/old/checks/searchAndLoadCheck': remotePaths.checks,
  '/old/profile': remotePaths.profile,
  '/old/profile/personalData': remotePaths.profile,
  '/old/profile/activityHistory': remotePaths.profileActivityHistory,
  '/old/profile/sign': remotePaths.profileSign,
  '/old/profile/accountsAbroad': remotePaths.profileAccountsAbroad,
  '/old/calendar': remotePaths.homePage,
  '/old/profile/participationInOrganizations': remotePaths.participationInOrganizations,
  '/old/profile/accounts': remotePaths.profileAccounts,
  '/old/profile/familyAccess': remotePaths.profileFamilyAccess,
  '/old/propertyObjects': remotePaths.propertyObjects,
  '/old/situations': remotePaths.situations,
  '/old/situations/3NDFL': remotePaths.situations,
  '/old/situations/registerIP': remotePaths.situations,
  '/old/situations/registerOrganization': remotePaths.situations,
  '/old/situations/ndfl3LightDeduction': remotePaths.situations,
  '/old/situations/disposeOfOverpayment': remotePaths.situations,
  '/old/situations/exemptions': remotePaths.situations,
  '/old/situations/foreignBankAccount': remotePaths.situations,
  '/old/situations/foreignBankAccount/openingForeignBankAccount': remotePaths.situations,
  '/old/situations/foreignBankAccount/closingForeignBankAccount': remotePaths.situations,
  '/old/situations/foreignBankAccount/changeAccountProps': remotePaths.situations,
  '/old/situations/foreignBankAccount/movementReportForm': remotePaths.situations,
  '/old/situations/foreignBankAccount/movementReportList': remotePaths.situations,
  '/old/situations/incorrectAccrual': remotePaths.situations,
  '/old/situations/incorrectAccrual/noChargesAppeal': remotePaths.noChargesAppeal,
  '/old/situations/other': remotePaths.situations,
  '/old/situations/other/hardCopy/1': remotePaths.needHardCopy,
  '/old/situations/other/hardCopy/2': remotePaths.refusalHardCopy,
  '/old/situations/other/makeComplaint': remotePaths.makeComplaint,
  '/old/situations/other/registrations': remotePaths.situations,
  '/old/situations/other/registrations/registerAsMediator': remotePaths.registerAsMediator,
  '/old/situations/other/registrations/unregisterMediator': remotePaths.unregisterAsMediator,
  '/old/situations/other/registrations/registerAsInsuranceTaxPayer':
    remotePaths.registerAsInsuranceTaxPayer,
  '/old/situations/other/registrations/unregisterInsuranceTaxPayer':
    remotePaths.unregisterAsInsuranceTaxPayer,
  '/old/situations/other/rejectLKFL': remotePaths.rejectLKFL,
  '/old/situations/other/setAddressToSendingTaxDocuments': remotePaths.appealTaxAddress,
  '/old/situations/referenceMaterials': remotePaths.situations,
  '/old/situations/referenceMaterials/requestForReconciliationAct': remotePaths.situations,
  '/old/situations/referenceMaterials/calculationStatus': remotePaths.situations,
  '/old/situations/referenceMaterials/statementOfEgrn': remotePaths.statementOfEgrn,
  '/old/situations/referenceMaterials/requestExecutionResponsibility': remotePaths.situations,
  '/old/situations/referenceMaterials/social': remotePaths.social,
  '/old/situations/referenceMaterials/innCertificateRequest': remotePaths.innCertificateRequest,
  '/old/situations/other/consentToInform': remotePaths.consentToInform,
  '/old/incomesAndTaxDeductions/userIncomes/DepositsCorrection': remotePaths.userIncomes,
  '/old/incomesAndTaxDeductions': remotePaths.declarations,
  '/old/incomesAndTaxDeductions/declarations': remotePaths.declarations,
  '/old/incomesAndTaxDeductions/taxDeductions': remotePaths.taxDeductions,
  '/old/incomesAndTaxDeductions/userIncomes': remotePaths.userIncomes,
  '/old/incomesAndTaxDeductions/userIncomes/declarationIncomes': remotePaths.declarations,
  '/old/incomesAndTaxDeductions/userIncomes/insuranceTaxes': remotePaths.insuranceTaxes,
  '/old/incomesAndTaxDeductions/userIncomes/percentDeposits': remotePaths.percentDeposits,
  '/old/help': remotePaths.help,
  '/old/help/services': remotePaths.helpServices,
  '/old/contacts': remotePaths.contacts,
  '/old/contacts/appointment': remotePaths.contacts,
  '/old/': remotePaths.homePage,
  '/old/situations/referenceMaterials/factOfGetting': remotePaths.factOfGettingSocialDeductions,
  '/old/situations/informForeignOrganization/kikNotification': remotePaths.kikNotification,
  '/old/situations/informForeignOrganization/informParticipationForeignOrganizations':
    remotePaths.informParticipationForeignOrganizations,
  '/old/situations/referenceMaterials/propertyTax': remotePaths.propertyTaxDeductions,
};

const routes = Object.freeze({
  '/login': {
    title: 'Авторизация',
  },
  '/taxpayerSearching': {
    title: 'Поиск налогоплательщика',
  },
  '/': {
    title: 'Главная',

    '/survey': {
      title: '',
      '/supportMeasures': {
        title: 'Какие меры поддержки Вам необходимы',
      },
    },

    '/openPdf': {
      title: 'Загрузка документа',
    },

    '/openLkApi': {
      title: 'Загрузка документа',
    },

    '/siteMap': {
      title: 'Карта сайта',
    },

    '/previewPdf': {
      title: 'Просмотр документа',
    },

    '/openTapsPdf': {
      title: 'Загрузка документа',
    },

    '/redirectToBank': {
      title: 'Перенаправление в банк',
    },

    '/myTaxes': {
      title: 'Мои налоги',

      '/wallet': {
        title: 'Единый налоговый платеж',

        '/payment': {
          title: 'Оплата',
        },
      },

      '/payment': {
        title: 'Оплата',

        '/bank': {
          title: 'Оплата через банк',
        },
      },

      '/detail': {
        title: 'Детали',
      },

      '/overpayment': {
        title: 'Переплата',
      },

      '/landTax': {
        title: 'Земельный налог',
      },

      '/transportTax': {
        title: 'Транспортный налог',
      },

      '/propertyTax': {
        title: 'Налог на имущество',
      },

      '/incomeTax': {
        title: 'Налог на доходы',

        '/detail': {
          title: 'Детали',
        },
      },
      '/admFines': {
        title: 'Административный штраф',
      },

      '/operationsHistory': {
        title: 'История операций',
      },

      '/checks': {
        title: 'Мои чеки',
        '/searchAndLoadCheck': {
          title: 'Загрузка чеков',
        },
      },

      '/judicialActs': {
        title: 'Судебные акты, принятые в пользу налоговых органов',
      },
      '/unexplainedPayments': {
        title: 'Невыясненные платежи',
      },
      '/administrativeFines': {
        title: 'Административный штраф',
      },

      '/selfInsuranceTaxes': {
        title: 'Страховые взносы за себя',
      },
    },

    '/propertyObjects': {
      title: 'Моё имущество',

      '/:objectId': {
        title: 'Моё имущество',
      },
    },

    '/helpBiggest': {
      title: 'Справочная информация',
    },

    '/help': {
      title: 'Помощь',

      '/services': {
        title: 'Электронные сервисы',
      },
    },

    '/faq': {
      title: 'Помощь',

      '/services': {
        title: 'Электронные сервисы',
      },
    },
    '/externalAppointment': {
      title: 'Запись на прием',
      details: {
        title: '',
      },
    },

    '/profile': {
      title: 'Профиль',

      '/personalData': {
        title: 'Персональные данные',
      },

      '/paymentInfo': {
        title: 'Платежная информация',
      },

      '/participationInOrganizations': {
        title: 'Участие в организациях',
      },

      '/activityHistory': {
        title: 'История действий',
      },

      '/sign': {
        title: 'Получить ЭП',
      },

      '/calendar': {
        title: 'Календарь',
      },

      '/survey': {
        title: 'Интерактивный помощник',
      },

      '/accounts': {
        title: 'Сведения о банковских счетах',
      },

      '/investAccounts': {
        title: 'Сведения об ИИС',
      },

      '/accountsAbroad': {
        title: 'Счета за рубежом',

        '/details': {
          title: '',
        },
      },
      '/familyAccess': {
        title: 'Семейный доступ',
      },
    },

    '/situations': {
      title: 'Жизненные ситуации',
      '/requestArmyMeasures': {
        title: 'Сообщить об отсутствии мер поддержки',
      },
      '/mobilizationReport': {
        title: 'Сообщить о факте мобилизации',
      },
      '/simplifiedDeductions': {
        title: 'Заявление о получении налоговых вычетов в упрощенном порядке',
      },
      '/other': {
        title: 'Прочие ситуации',

        '/appealInFreeForm': {
          title: 'Заявление в свободной форме',
        },

        '/makeComplaint': {
          title: 'Жалоба на акты налоговых органов, действия или бездействие должностных лиц',
        },

        '/registrations': {
          title: 'Постановка на учет или снятие с учета физического лица в налоговом органе',
          '/:page': {
            title: registrationTypeMap,
          },
        },
        '/rejectLKFL': {
          title: 'Уведомление об отказе от пользования сервисом ЛК',
        },
        '/hardCopy': {
          '/:actionType': {
            title: hardCopyTypeMap,
          },
        },
        '/consentToInform': {
          title:
            'Согласие (отказ) на информирование о наличии недоимки и (или) задолженности по пеням, штрафам, процентам',
        },

        '/taxSecrecy': {
          title: 'Раскрытие сведений, составляющих налоговую тайну',

          '/consentToPublicKnowledge': {
            title:
              'Согласие налогоплательщика (плательщика страховых взносов) на признание сведений, составляющих ' +
              'налоговую тайну, общедоступными',
          },
        },
        '/setAddressToSendingTaxDocuments': {
          title: 'Сообщить адрес для отправки налоговых документов',
        },
        '/searchPayment': {
          title: 'Запрос на розыск платежа',
        },
      },

      '/disposeOfOverpayment': {
        title: 'Распорядиться переплатой',
      },
      '/disposeOfOverpaymentEnp': {
        title: 'Распорядиться переплатой',
      },

      '/updatePersonalData': {
        title: 'Заявление на уточнение персональных данных',
      },

      '/detailsOrderClarification': {
        title: 'Уточнение реквизитов платежа',
      },

      '/incorrectAccrual': {
        title: 'Уточнить информацию об объектах налогообложения и (или) сумме налога',

        '/update': {
          title: 'Ошибка в характеристиках имущества',
        },

        '/objectDestruction': {
          title:
            'Заявление о гибели или уничтожении объекта налогообложения по налогу на имущество физических лиц',
        },

        '/transportDestruction': {
          title:
            'Заявление о гибели или уничтожении объекта налогообложения по транспортному налогу',
        },

        '/foreignObject': {
          title: 'Объект мне не принадлежит',
        },

        '/addObject': {
          title: 'Имущество отсутствует в личном кабинете',
        },

        '/taxNoticeClarification': {
          title: 'Заявление на уточнение налогового уведомления',
        },
        '/forObject': {
          title: 'Налог на имущество исчислен неправильно',
        },
        '/noChargesAppeal': {
          title: 'В личном кабинете отсутствуют начисления на моё имущество',
        },
      },

      '/3NDFL': {
        title: 'Налоговая декларация физических лиц (3-НДФЛ)',
      },

      '/3NDFLold': {
        title: 'Налоговая декларация физических лиц (3-НДФЛ)',
      },

      '/3NDFL_declaration': {
        title: 'Налоговая декларация физических лиц (3-НДФЛ)',
      },

      '/3NDFL_send_XML/:page': {
        title: 'Налоговая декларация физических лиц (3-НДФЛ)',
      },

      '/3NDFL_view_declaration/:declarationId': {
        title: 'Налоговая декларация физических лиц (3-НДФЛ)',

        '/attach_docs': {
          title: 'Налоговая декларация физических лиц (3-НДФЛ)',
        },

        '/attach_docs_success': {
          title: 'Налоговая декларация физических лиц (3-НДФЛ)',
        },
      },
      '/exemptions': {
        title: 'Льготы',

        '/notification': {
          title: 'Уведомление о выборе льготных объектов по налогу на имущество физических лиц',
        },
        '/applying': {
          title:
            'Заявление о предоставлении налоговой льготы по транспортному налогу, земельному налогу, налогу на имущество физических лиц',
        },
        '/applyingOld': {
          title:
            'Заявление о предоставлении налоговой льготы по транспортному налогу, земельному налогу, налогу на имущество физических лиц',
        },
        '/landTaxDeduction': {
          title:
            'Уведомление о выбранном земельном участке, в отношении которого применяется налоговый вычет по земельному налогу',
        },
      },
      '/reportExistenceObject': {
        title: 'В личном кабинете нет информации о моем имуществе',
      },

      '/referenceMaterials': {
        title: 'Документы и справки',
        '/requestExecutionResponsibility': {
          title: 'Запрос справки об исполнении обязанности по оплате налогов',
        },

        '/calculationStatus': {
          title: 'Запрос справки о состоянии расчетов',
        },

        '/requestForReconciliationAct': {
          title: 'Запрос акта совместной сверки',
        },

        '/social': {
          title: 'Заявление о подтверждении права на получение социальных вычетов',
        },

        '/innCertificateRequest': {
          title: 'Заявление физического лица о постановке на учет в налоговом органе',
        },
      },
      '/undefinedObject': {
        title: 'В личном кабинете нет информации о моем имуществе',
      },
      '/ndfl3LightDeduction': {
        title: 'Налоговые вычеты',

        '/propertyDeduction': {
          title: 'Вычет при покупке или строительстве нового жилья',
        },

        '/healingDeduction': {
          title: 'Вычет по расходам на лечение',
        },

        '/educationDeduction': {
          title: 'Вычет по расходам на обучение',
        },
        '/charityDeduction': {
          title: 'Вычет при расходах на благотворительность',
        },
        '/iisDeduction': {
          title: 'Вычет по взносам на инвестирование',
        },
      },

      '/ndfl3LightIncome': {
        title: 'Дополнительные доходы',

        '/rentalIncome': {
          title: 'Заявить о доходе от сдачи жилья в аренду',
        },

        '/propertySalesIncome': {
          title: 'Заявить о доходе от продажи имущества',
        },
      },
      '/setAddressToSendingTaxDocuments': {
        title: 'Сообщить адрес для отправки налоговых документов',
      },
      '/qualifiedSignatureApplication': {
        title: 'Заявление на получение квалифицированной электронной подписи',
      },
      '/percentDeposits': {
        title: 'Сообщение об уточнении представленной банком информации о сумме полученного дохода',
      },
    },

    '/contacts': {
      title: 'Контакты',

      '/search': {
        title: 'Добавление налогового органа',
      },

      '/appointment': {
        title: 'Записаться на прием в налоговый орган',

        '/:id': {
          title: 'Запись на прием',
        },
      },

      '/:id': {
        title: 'Налоговый орган',
      },
    },

    '/messages': {
      title: 'Сообщения от налогового органа',

      '/details': {
        title: '',
      },
      '/judicialOrder': {
        title: 'Судебные приказы',
        '/:cardId': {
          title: 'Судебные приказ',
        },
      },
      '/cameralAudits/:id': {
        title: 'Сведения о ходе проведения камеральных налоговых проверок и решениях на возврат',
      },
    },

    '/incomesAndTaxDeductions': {
      title: 'Доходы и вычеты',
      '/declarations': {
        title: 'Мои декларации',
      },
      '/taxDeductions': {
        title: 'Упрощенные вычеты',
      },
      '/userIncomes': {
        title: 'Доходы',
        '/declarationIncomes': {
          title: 'Декларации на прибыль',
        },
        '/insuranceTaxes': {
          title: 'Расчеты по страховым взносам',
        },
        '/percentDeposits': {
          title: 'Доходы в виде процентов по вкладам',
        },
      },
    },
  },
});

export default routes;
